import tokens from "./tokens";

const { color, radius, space, fontFamily } = tokens;

export const antdTheme = {
  token: {
    colorPrimary: color.brand,
    colorText: color.text.default,
    colorTextPlaceholder: color.placeholder.default,
    colorBorder: color.border.default,
    colorBgContainer: color.background.container,
    borderRadius: radius.sm,
    fontFamily: fontFamily.sans.join(", "),
    controlHeight: space.inputHeight
  }
};
